import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PdfRecieptService {
  public orderObserber:Subject<any>=new Subject()
  data :any

  private printInProgress = false;  // <- ADD THIS LINE

  constructor() {
  }

  printReceipt(data:any){    
    if (this.printInProgress) {
      console.warn('Duplicate print prevented');
      return;
    }
    this.printInProgress = true;

    setTimeout(()=>{
      window.print()
      this.printInProgress = false;  // reset after print
    },2000)
    this.data = {...this.data,...data}
    this.orderObserber.next(this.data)
  }
}
